import React, { useEffect } from 'react';
import './bigCountDown.scss';
import { useCounter } from '@hook/useCounter';
import dayjs from 'dayjs';
const BigCountDownPush = ({ variation }) => {
  const duration = variation?.timerTemplate?.duration || 0;
  const endTime = dayjs(variation?.timerTemplate?.endTime).diff(dayjs());
  const endTimeInSeconds = Math.floor(endTime.valueOf() / 1000);
  const { timer, reset } = useCounter({
    duration:
      variation?.timerTemplate?.countDownType === 'END_TIME'
        ? Math.max(endTimeInSeconds, 0)
        : duration || 0,
    local: 'sticky_countdown',
    immediate: true,
    isShowHours: true,
  });

  useEffect(() => {
    reset(true, true);
  }, []);

  return (
    <div className="wrapper">
      <span className="title-counter-big">
        {variation?.subject || 'Reminder'}
      </span>
      <span className="timer-desc-counter-big">
        {variation?.message ||
          'You car insurance is expiring in 1 day. Click here to renew now!'}
      </span>
      <div className="big-timer-wrapper">
        <div className="big-timer">
          <div className="big-timer-part">
            <span
              className="counter"
              style={{ color: variation?.timerTemplate?.timeColor }}
            >
              {timer}
            </span>
            <div className="label-count">
              <span className="unit">HOURS</span>
              <span className="unit">MINUTES</span>
              <span className="unit">SECONDS</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export { BigCountDownPush };
